import {
  createSelector,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";

import type { RootState } from "../../app/store";
import { safeLocalStorage } from "../utils/utils";
import { FindMyCarStatusTypes, type SliceProps } from "./types";

const initialState: SliceProps = {
  coordinates: safeLocalStorage.getItem("find-my-car")
    ? (JSON.parse(safeLocalStorage.getItem("find-my-car") || "") as SliceProps)
        ?.coordinates
    : null,
  floorId: safeLocalStorage.getItem("find-my-car")
    ? (JSON.parse(safeLocalStorage.getItem("find-my-car") || "") as SliceProps)
        ?.floorId
    : null,
  status: safeLocalStorage.getItem("find-my-car")
    ? (JSON.parse(safeLocalStorage.getItem("find-my-car") || "") as SliceProps)
        ?.status
    : FindMyCarStatusTypes.UNSET,
};

export const FindMyCarSlice = createSlice({
  initialState,
  name: "findMyCar",
  reducers: {
    setFindMyCar: (state: SliceProps, action: PayloadAction<SliceProps>) => {
      state.status = action.payload.status;
      state.coordinates = action.payload.coordinates;
      state.floorId = action.payload.floorId;
    },
    setFindMyCarStatus: (
      state: SliceProps,
      action: PayloadAction<SliceProps["status"]>,
    ) => {
      state.status = action.payload;
    },
  },
});

// Selectors
const sliceData = (state: RootState) => state.findMyCar;

export const selectFindMyCar = createSelector(
  sliceData,
  (item) => {
    return item;
  },
  {
    devModeChecks: { identityFunctionCheck: "never" },
  },
);

// Action creators are generated for each case reducer function
export const { setFindMyCar, setFindMyCarStatus } = FindMyCarSlice.actions;

export default FindMyCarSlice.reducer;
